import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';
// import { enqueueSnackbar } from "notistack";
import { FaBasketShopping } from "react-icons/fa6";
import { TbTruckDelivery } from "react-icons/tb";
import { FaShop } from "react-icons/fa6";
import { FaUserCircle } from "react-icons/fa";
import { BsHourglassSplit } from "react-icons/bs";
import { FiDollarSign } from "react-icons/fi";
import { MdKeyboardArrowRight } from "react-icons/md";

import DropDown from "../../components/common/Dropdown";
import { hostNameBack } from '../../utils/constants';
import Loader from '../../utils/Loader';

const Orders = ({ pageType }) => {
  const [searchParams] = useSearchParams();

  const [orders, setOrders] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(pageType === "dashboard" ? "Active" : "All");
  const [ordersType, setOrdersType] = useState(searchParams.get("s") === "t" ? "Services" : "All");
  const token = localStorage.getItem("token");
  const productFilters = ["All", "Active", "Shipped", "Delivered", "Completed", "On Hold", "Cancelled", "InDispute", "Resolved"];
  const serviceFilters = ["All", "Active", "Delivered", "Completed", "Cancelled", "Past Due", "InDispute", "Resolved"];
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const fetchOrders = async () => {
      try {
        let productOrders = [];
        let serviceOrders = [];
        const headers = { Authorization: `Bearer ${token}` };

        if (pageType === "buyer") {
          if (ordersType === "Products" || ordersType === "All") {
            const productUrl = `${hostNameBack}/api/v1/orders/buyer/product/all`;
            const productResponse = await axios.get(productUrl, { headers });
            if (productResponse.data.success) {
              productOrders = productResponse.data.orders;
            }
          }
          if (ordersType === "Services" || ordersType === "All") {
            const serviceUrl = `${hostNameBack}/api/v1/orders/buyer/service/all`;
            const serviceResponse = await axios.get(serviceUrl, { headers });
            if (serviceResponse.data.success) {
              serviceOrders = serviceResponse.data.orders;
            }
          }
        } else if (pageType === "seller" || pageType === "dashboard") {
          if (ordersType === "Products" || ordersType === "All") {
            const productUrl = `${hostNameBack}/api/v1/orders/seller/product/all`;
            const productResponse = await axios.get(productUrl, { headers });
            if (productResponse.data.success) {
              productOrders = productResponse.data.orders;
            }
          }
          if (ordersType === "Services" || ordersType === "All") {
            const serviceUrl = `${hostNameBack}/api/v1/orders/seller/service/all`;
            const serviceResponse = await axios.get(serviceUrl, { headers });
            if (serviceResponse.data.success) {
              serviceOrders = serviceResponse.data.orders;
            }
          }
        }

        if (ordersType === "Products") {
          setOrders(productOrders.map(order => ({ type: "product", order })));
        } else if (ordersType === "Services") {
          setOrders(serviceOrders.map(order => ({ type: "service", order })));
        } else if (ordersType === "All") {
          setOrders([
            ...productOrders.map(order => ({ type: "product", order })),
            ...serviceOrders.map(order => ({ type: "service", order }))
          ]);
        }
      } catch (e) {
        // enqueueSnackbar(e?.response?.data?.error || "Something went wrong!", { variant: "error" });
      } finally {
        setIsLoading(false);
      }
    };
    fetchOrders();
  }, [token, pageType, ordersType]);

  const handleOrdersTypeChange = (type) => {
    setOrdersType(type);
    setSelectedFilter(pageType === "dashboard" ? "Active" : "All");
  };

  const calculateDeadline = (orderDate, deliveryDays) => {
    const deadline = new Date(orderDate);
    deadline.setDate(deadline.getDate() + deliveryDays);
    const options = { month: 'short', day: 'numeric', year: '2-digit' };
    return deadline.toLocaleDateString(undefined, options);
  };

  const OrderCard = ({ type, order }) => {
    const badge = <span className={`orderTypeBadge ${type}`}>{type === "product" ? "Product Order" : "Service Order"}</span>;

    if (type === "product") {
      if (!order.products) return null;
      let noOfAnyUnreads = 0;
      const filteredProducts = order.products.filter(product => {
        if (selectedFilter === "All" || selectedFilter === product.status[product.status.length - 1].name) {
          if (pageType === "buyer" && product.noOfUnreadByBuyer > 0) noOfAnyUnreads+= product.noOfUnreadByBuyer;
          if ((pageType === "seller" || pageType === "dashboard") && product.noOfUnreadBySeller > 0) noOfAnyUnreads+= product.noOfUnreadBySeller;
          return true;
        }
        return false;
      });
      if (filteredProducts.length === 0) return null;

      if (pageType === "buyer") {
        return (
          <div className="buyerProductOrderCard">
            {ordersType === "All" && badge}
            {filteredProducts.map((product, i) => (
              <div key={i}>
                <div className="order">
                  <div className="left">
                    <div className="leftLeft">
                      <div className="imgDiv">
                        <img src={`${product.productId?.productImages[0]}`} alt="Product Thumbnail" />
                      </div>
                      <div className="productInfo">
                        <p className='singleLineText'>{product.productId?.title}</p>
                        <p className='category'>{product.productId?.category}</p>
                      </div>
                    </div>
                    <div className="leftRight">
                      <div className="column">
                        <p><FaShop className='icon' /></p>
                        <Link to={`/profile/${product?.productId?.sellerId?._id}`}>{product.productId?.sellerId?.userId?.username + " >"}</Link>
                      </div>
                      <div className="column">
                        <p><FaBasketShopping className='icon' /></p>
                        <div>{product.count < 10 ? "0" + product.count : product.count}</div>
                      </div>
                      <div className="column">
                        <p><TbTruckDelivery className='icon' /></p>
                        <div>{product.status[product.status.length - 1].name}</div>
                      </div>
                      <div className="column responsivePrice">
                        <p><FiDollarSign className='icon' /></p>
                        <div>${product.buyerPaid.salesPrice}</div>
                      </div>
                    </div>
                  </div>
                  <div className="right">
                    <div className="price">${product.buyerPaid.salesPrice}</div>
                    <Link to={`/chat?p=${product?.productId?.sellerId?.userId?._id}`} className='secondaryBtn'>{"Contact Seller >"}</Link>
                  </div>
                </div>
                <div className='horizontalLine'></div>
              </div>
            ))}
            <div className='actionsDiv'>
              <Link to={`/orders/product/orderDetails/${order._id}`}>View Order <MdKeyboardArrowRight className='icon' /> {noOfAnyUnreads > 0 && <span className="notifications-badge">{noOfAnyUnreads}</span>}</Link>
            </div>
          </div>
        );
      } else {
        return (
          <div className='subOrders'>
            {filteredProducts.map((product, i) => (
              <div className="sellerProductOrderCard" key={i}>
                {ordersType === "All" && badge}
                <div className="order">
                  <div className="left">
                    <div className="leftLeft">
                      <div className="imgDiv">
                        <img src={`${product.productId?.productImages[0]}`} alt="Product Thumbnail" />
                      </div>
                      <div className="productInfo">
                        <p className='singleLineText'>{product.productId?.title}</p>
                        <p className='category'>{product.productId?.category}</p>
                      </div>
                    </div>
                    <div className="leftRight">
                      <div className="column">
                        <p><FaUserCircle className='icon' /></p>
                        <div>{order.userId?.username}</div>
                      </div>
                      <div className="column">
                        <p><FaBasketShopping className='icon' /></p>
                        <div>{product.count < 10 ? "0" + product.count : product.count}</div>
                      </div>
                      <div className="column">
                        <p><TbTruckDelivery className='icon' /></p>
                        <div>{product.status[product.status.length - 1].name}</div>
                      </div>
                      <div className="column responsivePrice">
                        <p><FiDollarSign className='icon' /></p>
                        <div>${product.sellerToGet.salesPrice}</div>
                      </div>
                    </div>
                  </div>
                  <div className="right">
                    <div className="price">${product.sellerToGet.salesPrice}</div>
                    <Link to={`/chat?p=${order?.userId?._id}`} className='secondaryBtn'>{"Contact Buyer >"}</Link>
                  </div>
                </div>
                <div className='horizontalLine'></div>
                <div className='actionsDiv'>
                  <Link to={`/seller/orders/product/orderDetails/${order._id}/${product._id}`}>{"View Order >"} {product?.noOfUnreadBySeller > 0 && <span className="notifications-badge">{product.noOfUnreadBySeller}</span>}</Link>
                </div>
              </div>
            ))}
          </div>
        );
      }
    } else if (type === "service") {
      const crrService = order.service;
      if (!crrService) return null;
      const filteredServices = selectedFilter === "All" || selectedFilter === crrService.status[crrService.status.length - 1].name;
      if (!filteredServices) return null;
      const deadline = calculateDeadline(order.createdAt, crrService.pkg.deliveryDays);

      if (pageType === "buyer") {
        return (
          <div className="buyerProductOrderCard">
            {ordersType === "All" && badge}
            <div>
              <div className="order">
                <div className="left">
                  <div className="leftLeft">
                    <div className="imgDiv">
                      <img src={`${crrService.serviceId?.serviceImages && crrService.serviceId?.serviceImages[0]}`} alt="Service Thumbnail" />
                    </div>
                    <div className="productInfo">
                      <p className='singleLineText'>{crrService.serviceId?.title}</p>
                      <p className='category'>{crrService.serviceId?.category}</p>
                    </div>
                  </div>
                  <div className="leftRight">
                    <div className="column">
                      <p><FaShop className='icon' /></p>
                      <Link to={`/profile/${crrService?.serviceId?.sellerId?._id}`}>{crrService.serviceId?.sellerId?.userId?.username + " >"}</Link>
                    </div>
                    <div className="column">
                      <p><TbTruckDelivery className='icon' /></p>
                      <div>{crrService.status[crrService.status.length - 1].name}</div>
                    </div>
                    <div className="column">
                      <p><BsHourglassSplit className='icon' /></p>
                      <div>{deadline}</div>
                    </div>
                    <div className="column responsivePrice">
                      <p><FiDollarSign className='icon' /></p>
                      <div>${order.summary.paidByBuyer.salesPrice}</div>
                    </div>
                  </div>
                </div>
                <div className="right">
                  <div className="price">${order.summary.paidByBuyer.salesPrice}</div>
                  <Link to={`/chat?p=${crrService.serviceId?.sellerId?.userId?._id}`} className='secondaryBtn'>{"Contact Seller >"}</Link>
                </div>
              </div>
              <div className="horizontalLine"></div>
            </div>
            <div className='actionsDiv'>
              <Link to={`/orders/posting/orderDetails/${order._id}`}>{"View Order >"} {order?.noOfUnreadByBuyer > 0 && <span className="notifications-badge">{order.noOfUnreadByBuyer}</span>}</Link>
            </div>
          </div>
        );
      } else {
        return (
          <div className="buyerProductOrderCard">
            {ordersType === "All" && badge}
            <div>
              <div className="order">
                <div className="left">
                  <div className="leftLeft">
                    <div className="imgDiv">
                      <img src={`${crrService.serviceId?.serviceImages && crrService.serviceId?.serviceImages[0]}`} alt="Service Thumbnail" />
                    </div>
                    <div className="productInfo">
                      <p className='singleLineText'>{crrService.serviceId?.title}</p>
                      <p className='category'>{crrService.serviceId?.category}</p>
                    </div>
                  </div>
                  <div className="leftRight">
                    <div className="column">
                      <p><FaUserCircle className='icon' /></p>
                      <div>{order.userId?.username}</div>
                    </div>
                    <div className="column">
                      <p><TbTruckDelivery className='icon' /></p>
                      <div>{crrService.status[crrService.status.length - 1].name}</div>
                    </div>
                    <div className="column">
                      <p><BsHourglassSplit className='icon' /></p>
                      <div>{deadline}</div>
                    </div>
                    <div className="column responsivePrice">
                      <p><FiDollarSign className='icon' /></p>
                      <div>${order.summary.sellerToGet.salesPrice}</div>
                    </div>
                  </div>
                </div>
                <div className="right">
                  <div className="price">${order.summary.sellerToGet.salesPrice}</div>
                  <Link to={`/chat?p=${order.userId?._id}`} className='secondaryBtn'>{"Contact Buyer >"}</Link>
                </div>
              </div>
              <div className="horizontalLine"></div>
            </div>
            <div className='actionsDiv'>
              <Link to={`/seller/orders/posting/orderDetails/${order._id}`}>{"View Order >"} {order?.noOfUnreadBySeller > 0 && <span className="notifications-badge">{order.noOfUnreadBySeller}</span>}</Link>
            </div>
          </div>
        );
      }
    }
    return null;
  };

  const hasOrders = orders && (ordersType === "Products"
    ? orders.some(order => order.type === "product" && order.order.products && order.order.products.some(product =>
      selectedFilter === "All" || selectedFilter === product.status[product.status.length - 1].name
    ))
    : ordersType === "Services"
      ? orders.some(order => order.type === "service" && order.order.service && (selectedFilter === "All" || selectedFilter === order.order.service.status[order.order.service.status.length - 1].name))
      : orders.some(order =>
        (order.type === "product" && order.order.products && order.order.products.some(product =>
          selectedFilter === "All" || selectedFilter === product.status[product.status.length - 1].name
        )) ||
        (order.type === "service" && order.order.service && (selectedFilter === "All" || selectedFilter === order.order.service.status[order.order.service.status.length - 1].name))
      ));

  return (
    <div className='ordersDiv'>
      <section className="section">
        <div className="ordersContent">
          <div className="responsiveFilters">
            {pageType !== "dashboard" &&
              <DropDown options={ordersType === "Products" ? productFilters : serviceFilters} selected={selectedFilter} onSelect={setSelectedFilter} />}
            <DropDown options={["All", "Products", "Services"]} selected={ordersType} onSelect={handleOrdersTypeChange} />
          </div>

          <div className="upper">
            <section className="section">
              <h2 className="primaryHeading">{selectedFilter} <span>Orders</span></h2>
              <div className="upperRight">
                {pageType !== "dashboard" &&
                  <DropDown options={ordersType === "Products" ? productFilters : serviceFilters} selected={selectedFilter} onSelect={setSelectedFilter} />}
                <DropDown options={["All", "Products", "Services"]} selected={ordersType} onSelect={handleOrdersTypeChange} />
              </div>
            </section>
          </div>

          <div className="orders">
            {isLoading ? <Loader type="simpleMini" /> :
              hasOrders ?
                orders.map((item, index) => (
                  <OrderCard key={index} type={item.type} order={item.order} />
                ))
                : "Nothing to show here!"
            }
          </div>
        </div>
      </section>
    </div>
  );
};

export default Orders;